export default "__VITE_ASSET__BnmCVoeF__"